import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import { 
    EmptyState, 
    BaasicButton,
    DateQueryPicker,
    QueryDropdown
} from 'core/components';
import { toJS} from 'mobx';
import { Content } from "core/layouts";
import PivotTableUI from 'react-pivottable/PivotTableUI';
import 'react-pivottable/pivottable.css';

const PivotListTemplate = function ({ pivotListViewStore, t }) {
    const {  
        pivotData, 
        setProps, 
        pivotTableProps,
        queryUtility,
        dateFromStore,
        dateToStore,
        isLoading,
        departmentStore,
        cols,
        changeLayout
     } = pivotListViewStore;

    return (
        <Content emptyRenderer={renderEmpty()}>
            <div className="pivot is-collapsed">
                <div className="container">
                    <div className='row row--form u-mar--bottom--sml u-mar--top--lrg'>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 u-padd--left--tny">
                            <label className="form__group__label">From</label>
                            <DateQueryPicker store={dateFromStore} queryUtility={queryUtility} propertyName='dateFrom'/>
                        </div>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2">
                            <label className="form__group__label">To</label>
                            <DateQueryPicker store={dateToStore} queryUtility={queryUtility} propertyName='dateTo'/>
                        </div>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2">
                            <QueryDropdown queryUtility={queryUtility} store={departmentStore} propertyName="department" label="Department" />
                        </div>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2">
                            <div className="u-flex--primary">
                                <BaasicButton
                                    type='button'
                                    className="btn btn--base btn--primary"
                                    onClick={() => queryUtility.fetch()}
                                    rotate
                                    icon={
                                        isLoading
                                            ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                                            : 'u-display--none'
                                    }
                                    disabled={isLoading}
                                    label={t('GRID.FILTER.SEARCH_BUTTON')}
                                />
                                <BaasicButton
                                    type='button'
                                    className="btn btn--base btn--ghost u-mar--left--tny"
                                    onClick={() => queryUtility.resetFilter()}
                                    label={t('GRID.FILTER.CLEAR_BUTTON')}
                                />
                            </div>
                        </div>
                        <div className="col col-sml-12 col-med-6 col-lrg-8 col-xxlrg-4 u-mar--top--med">
                            <BaasicButton
                                type='button'
                                className="btn btn--base btn--ghost u-mar--left--tny"
                                onClick={() => changeLayout("team")}
                                label="By Team"
                            />
                            <BaasicButton
                                type='button'
                                className="btn btn--base btn--ghost u-mar--left--tny"
                                onClick={() => changeLayout("person")}
                                label="By Person"
                            />                        
                            <BaasicButton
                                type='button'
                                className="btn btn--base btn--ghost u-mar--left--tny"
                                onClick={() => changeLayout("department")}
                                label="By Department"
                            />
                        </div>
                    </div>
                    <PivotTableUI
                        rows={['month','day']}
                        cols={toJS(cols)}
                        vals={['active']}
                        aggregatorName={'Integer Sum'}
                        hiddenAttributes={['calendar','dateCreated','dateUpdated','facilityId','facilityScheduleTypeId','id','personId','accountRepId']}
                        qhiddenFromDragDrop={['calendar','dateCreated','dateUpdated','facilityId','facilityScheduleTypeId','id','personId']}
                        data={pivotData}
                        showUI={true}
                        onChange={s => setProps(s)}
                        draggableAttributes={['department','accountManager','name']}
                        rendererName={'Heatmap'}
                        colSubtotalDisplay={true}
                        {...pivotTableProps}
                    />
                </div>
            </div>
        </Content>
    );
};

function renderEmpty() {
    return (
        <EmptyState
            title="PIVOT.LIST.EMPTY_STATE.TITLE"
            actionLabel="PIVOT.LIST.EMPTY_STATE.ACTION"
        />
    );
}

PivotListTemplate.propTypes = {
    pivotListViewStore: PropTypes.object.isRequired,
    t:PropTypes.func
};

export default defaultTemplate(PivotListTemplate);